import { render, staticRenderFns } from "./VatEditModal.vue?vue&type=template&id=18aa4b04"
import script from "./VatEditModal.vue?vue&type=script&lang=ts"
export * from "./VatEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18aa4b04')) {
      api.createRecord('18aa4b04', component.options)
    } else {
      api.reload('18aa4b04', component.options)
    }
    module.hot.accept("./VatEditModal.vue?vue&type=template&id=18aa4b04", function () {
      api.rerender('18aa4b04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/VatEditModal.vue"
export default component.exports